import { Dispatch } from '@reduxjs/toolkit';
import { rootStore } from '../mobx/rootStore';

/**
 * @desc Clear Inbox Data
 */
export const clearInboxData = () => (dispatch: Dispatch) => {
  rootStore.notificationStore.setNotifications([]);
};
